import { render, staticRenderFns } from "./dictList.vue?vue&type=template&id=e53ff518&lang=pug"
import script from "./dictList.vue?vue&type=script&lang=js"
export * from "./dictList.vue?vue&type=script&lang=js"
import style0 from "./dictList.vue?vue&type=style&index=0&id=e53ff518&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports